export function compute_tax_TSV24(prix) {
    // Si le prix est à 0, la taxe est de 0
    if (prix == 0) return 0;
    // Si le prix est inférieur à 9, la taxe est de 0,5
    if (prix < 9) {
        return 0.5;
    }
    // Si le prix est compris entre 9 et 100, la taxe est de 7% ou 1,2€, ce qu'il y a de plus élevé
    if (prix >= 9 && prix < 100) {
        let taxe = (prix * 7) / 100;
        taxe = Math.max(1.2, taxe);
        taxe = Math.min(5.6, taxe);
        return parseFloat(taxe);
    }
    // Si le prix est compris entre 100 et 200, la taxe est de 6%
    if (prix >= 100 && prix < 200) {
        let taxe = (prix * 6) / 100;
        taxe = Math.min(5.6, taxe);
        return parseFloat(taxe);
    }
    // Si le prix est supérieur ou égal à 200, la taxe est de 5%
    if (prix >= 200) {
        let taxe = (prix * 5) / 100;
        taxe = Math.min(5.6, taxe);
        return parseFloat(taxe);
    }
}

export function compute_tax_CALAD26(prix) {
    if (prix < 8) return 0;
    // Si le prix est compris entre 9 et 100, la taxe est de 7% ou 1,2€, ce qu'il y a de plus élevé
    if (prix >= 8 && prix < 100) {
        let taxe = (prix * 7) / 100;
        taxe = Math.max(1.2, taxe);
        taxe = Math.min(5.6, taxe);
        return parseFloat(taxe);
    }
    // Si le prix est compris entre 100 et 200, la taxe est de 6%
    if (prix >= 100 && prix < 200) {
        let taxe = (prix * 6) / 100;
        taxe = Math.min(5.6, taxe);
        return parseFloat(taxe);
    }
    // Si le prix est supérieur ou égal à 200, la taxe est de 5%
    if (prix >= 200) {
        let taxe = (prix * 5) / 100;
        taxe = Math.min(5.6, taxe);
        return parseFloat(taxe);
    }

}

export function compute_tax_MAXIRACE26(prix) {
    if (prix == 0) return 0;
    let taxe = (prix * 6) / 100;
    return parseFloat(taxe);
}

export function compute_tax_TSV25(prix) {
    // Si le prix est à 0, la taxe est de 0
    if (prix == 0) return 0;
    // Si le prix est inférieur à 9, la taxe est de 0,5
    if (prix < 9) {
        return 0.5;
    }
    // Si le prix est compris entre 9 et 100, la taxe est de 7% ou 1,2€, ce qu'il y a de plus élevé
    if (prix >= 9 && prix < 100) {
        let taxe = (prix * 7) / 100;
        taxe = Math.max(1.2, taxe);
        taxe = Math.min(5.8, taxe);
        return parseFloat(taxe);
    }
    // Si le prix est compris entre 100 et 200, la taxe est de 6%
    if (prix >= 100 && prix < 200) {
        let taxe = (prix * 6) / 100;
        taxe = Math.min(5.8, taxe);
        return parseFloat(taxe);
    }
    // Si le prix est supérieur ou égal à 200, la taxe est de 5%
    if (prix >= 200) {
        let taxe = (prix * 5) / 100;
        taxe = Math.min(5.8, taxe);
        return parseFloat(taxe);
    }
}

export function compute_tax_TSV26(prix, booking) {

    // Si le prix est à 0, la taxe est de 0
    if (prix == 0) return 0;
    // Si le prix est inférieur à 9, la taxe est de 0,5
    if (prix < 9) {
        return 0.5;
    }
    // Si le prix est supérieur ou égal à 9, la taxe est de 5%
    if (prix >= 9) {
        let taxe = (prix * 5) / 100;
        taxe = Math.max(1.2, taxe);
        if (taxe > 5.8 && has_dossard_solidaire_in_cart_TSV26(booking)) {
            return 5.8;
        }
        return parseFloat(taxe);
    }
}

function has_dossard_solidaire_in_cart_TSV26(booking) {
    if (!booking) return false;
    if (!booking.inscriptions) return false;
    for (const inscription of booking.inscriptions) {
        if (!inscription.list_courses) continue;
        for (const course of inscription.list_courses.list) {
            if (course.selected && (course.id == 1672 || course.id == 1673)) {
                return true;
            }
        }
    }
    return false;
}

export function compute_tax_CAPVAR25(prix) {
    if (prix == 0) return 0;
    return 0.9;
}

export function compute_tax_CVRIB25(prix) {
    if (prix == 0) return 0;
    return 0.9;
}

export function compute_tax_XCOAIX(prix) {
    if (prix == 0) return 0;
    return 0.9;
}



export function compute_tax_CAPVAR24(prix) {
    if (prix == 0) return 0;
    return 0.9;
}

export function compute_tax_VTTCAV24(prix) {
    if (prix == 0) return 0;
    return 0.9;
}

export function compute_tax_TMB24(prix) {
    if (prix == 0) return 0;
    return 29;
}


export function compute_tax_RUNFEST26(prix) {
    if (prix == 0) return 0;
    let taxe = (prix * 5) / 100;
    return parseFloat(taxe);
}



export function compute_tax_ENR24(cart) {
    let tax = 0;
    let count_courses_selected = {};
    // foreach inscriptions in cart
    cart.inscriptions.forEach(inscription => {
        inscription.list_courses.list.forEach(course => {
            if (course.selected) {
                if (!count_courses_selected[course.id]) {
                    count_courses_selected[course.id] = 1;
                }
                else {
                    count_courses_selected[course.id] += 1;
                }
            }
        })
    });

    if (count_courses_selected[359]) {
        let count = count_courses_selected[359] / 2;
        tax += Math.ceil(count) * 9;
    }
    if (count_courses_selected[360]) {
        let count = count_courses_selected[360] / 4;
        tax += Math.ceil(count) * 18;
    }
    if (count_courses_selected[361]) {
        let count = count_courses_selected[361] / 6;
        tax += Math.ceil(count) * 27;
    }

    return tax;
}
